export interface FileToUpload {
  label: string;
  file?: File;
  url?: string;
  existent?: boolean;
  deleted?: boolean;
  invalid?: boolean;
}